import { render } from "./StafetDeltagSomFighterStepOne.vue?vue&type=template&id=1baaca5b"
import script from "./StafetDeltagSomFighterStepOne.vue?vue&type=script&lang=js"
export * from "./StafetDeltagSomFighterStepOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__